import React from 'react';
import { Link } from 'react-router-dom';
import AppsLayout from './AppsLayout';
import Button from './components/Button';
import { PolicyArticle, PolicyContents } from './components/PolicyContent';
import policy from '../../content/numbcrunch/terms.json';
import { trackClick } from '../../firebase/analytics';
import { APPS_ROUTES, SITE_ORIGIN } from './routes';

const PAGE = 'apps_numbcrunch_terms';

export default function NumbCrunchTermsPage() {
  return (
    <AppsLayout
      title="NumbCrunch terms of service · Keval Langalia"
      description="The complete NumbCrunch Android game Terms of Service: your license to use the app, what you agree not to do, ownership, disclaimers, Google Play and how to contact us."
      canonicalPath={APPS_ROUTES.numbcrunchTerms}
      breadcrumbs={[
        { label: 'Portfolio', to: APPS_ROUTES.apps, id: 'apps' },
        { label: 'NumbCrunch', to: APPS_ROUTES.numbcrunch, id: 'numbcrunch' },
        { label: 'Terms of service' },
      ]}
      page={PAGE}
      support={false}
    >
      <header className="apps-policy-header">
        <p className="apps-eyebrow">{policy.app} · Terms</p>
        <h1 className="apps-title">{policy.title}</h1>
      </header>
      <div className="apps-policy">
        <PolicyContents policy={policy} label="Terms contents" />
        <div>
          <PolicyArticle policy={policy} label="NumbCrunch terms of service" localOrigin={SITE_ORIGIN} />
          <div className="apps-hero-actions apps-policy-followup">
            <Button to={APPS_ROUTES.numbcrunch} variant="secondary" onClick={trackClick(PAGE, 'back_to_numbcrunch_button')}>
              Back to NumbCrunch
            </Button>
            <Link to={APPS_ROUTES.apps} className="kds-btn kds-btn--text" onClick={trackClick(PAGE, 'all_apps_link')}>
              All projects
            </Link>
          </div>
        </div>
      </div>
    </AppsLayout>
  );
}
